import styled from "styled-components";

export const TableWrapper = styled.div`
  .backbutton-sec {
    margin-bottom: 20px;
    font-family: "Inter";
    font-size: 22.54px;
    font-weight: 400;
    line-height: 27.27px;
    margin-left: 20px;
  }
  .backbutton-sec img {
    width: 25px;
    height: 25px;
    margin-left: -10px;
    cursor: pointer;
  }
  .status-Pendiente {
    color: red;
  }
  .sectionwrapper {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    margin: 20px;
    background-color: #ffffff;
    box-shadow: 0px 0px 5px 1px #00000026;
    font-family: "Inter";
  }
  .cashback-balance-div {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 20px;
    box-shadow: 0px 2px 7px 0px #00000026;
    width: auto;
  }
  .cashback-balance-div .text {
    margin: 0;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .amount-sec-val {
    margin: 0;
    color: #ff4b31;
    font-family: Inter;
    font-weight: 600;
    font-size: 24px;
  }
  .amount-sec-val1 {
    color: #000;
  }
  .amount-sec-val2 {
    color: green;
  }
  .amount-sec-val1 {
    color: #000;
  }
  table {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    background-color: #ffffff;
    box-shadow: 0px 0px 5px 1px #00000026;
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
  }

  th,
  td {
    border-left: 1px solid #ececec;
    border-right: 1px solid #ececec;
    border-top: none;
    border-bottom: none;
    padding: 15px;
    text-align: center;
  }

  th {
    background-color: #ffffff;
    font-weight: bold;
    border-bottom: 1px solid #ddd;
  }
  .info-icon {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    cursor: pointer;
  }

  .tooltiptext{
    position: absolute;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    font-size: 12px;
    color: #333;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 100;
    max-width: 300px;
    right: 95px;
  }

  /* tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  tr:hover {
    background-color: #f1f1f1;
  } */
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const StatusDot = styled.span<{ status: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.status === "Pending" ? "yellow" : "green"};
`;
